import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalsService {
  // Local

  // dataUrl='http://10.211.55.3/xworksv3/';

  // dataUrl = 'http://localhost/xworks-v3-test-03102022/';

  // dataUrl = 'http://localhost/salud/';
  dataUrl = 'https://saluddigitalprodapi-dycqcpdyhwbsa6dr.eastus2-01.azurewebsites.net/';
  // dataUrl = 'https://xworks-salud-be-g8h8b6agd5bweheg.canadacentral-01.azurewebsites.net/';
  sa = 'https://xworkssa.blob.core.windows.net/uploadedfiles';
  // sa = 'https://saluddigitalprodstorage.blob.core.windows.net/uploadedfiles';

  // dataUrl = 'https://jrspdigital-api-prod.azurewebsites.net/';
  // sa = 'https://jrspdigitalsa.blob.core.windows.net/uploadedfiles';

  // SanJuan Api
  // dataUrl='https://xworks-v3-api-sanjuan.azurewebsites.net/';
  // Test

  // dataUrl='https://xworks-prgov-test-be.azurewebsites.net/';
  // dataUrl = 'https://xworks-v3-csi-test-be.azurewebsites.net/';

  // Test CSI V3 Created: 5-21-2021
  // dataUrl='https://xworks-v3-csi-test-fe.azurewebsites.net';
  // dataUrl='https://xworks-v3-csi-test-be.azurewebsites.net/';
  // dataUrl = 'https://xworks-v2-dev-api.azurewebsites.net/';

  // Demo
  // dataUrl = 'https://xworks-v3-demo-be.azurewebsites.net/';

  // DRNA
  // dataUrl = 'https://xworks-drna-api.azurewebsites.net/';

  // Transporte

  // dataUrl = 'https://xworks-salud-be-prop-h4dpdpa9byckfmga.canadacentral-01.azurewebsites.net/';
  
  // dataUrl = 'https://d7a5-2803-6d00-a200-6e00-4838-95b5-e8a1-5ee9.ngrok-free.app/xworks-v3-test-03102022/';
  //dataUrl = 'http://localhost/salud/';
  // sa = 'https://xworkssa.blob.core.windows.net/uploadedfiles';
  
  // Transporte Prod
  // dataUrl = 'https://jrspdigital-api-prod.azurewebsites.net/'

  // DRNA TEST
  // dataUrl = 'https://xworks-v3-dev-be.azurewebsites.net/';
  // dataUrl = 'http://localhost/xworks-v3-test-03102022/';
  // DRNA PROD
  // dataUrl = 'https://xworks-drna-api-prod.azurewebsites.net/';
  // Departamento de Estado
  // dataUrl='https://xworks-v3-csi-be.azurewebsites.net/';
  // Prod
  // dataUrl='https://prgov-certs-api.azurewebsites.net/';
  // dataUrl='https://xworksv2-test-api.azurewebsites.net/';
  // dataUrl='https://xworks-v2-dev-api.azurewebsites.net/';
  // dataUrl='https://xworks-v2-dev-api.azurewebsites.net/'
  // dataUrl = ' https://xworks-v3-csi-be.azurewebsites.net/'
  // dataUrl='https://xworksv2-prgov-test-api.azurewebsites.net/';
  
  // OIPC
  // dataUrl = 'https://oipcdigital-api-prod.azurewebsites.net/';

  // NEPR
  // dataUrl = 'https://neprdigital-api-prod.azurewebsites.net/';

  // NET
  // dataUrl = 'https://netdigital-api-prod.azurewebsites.net/';

  // Storage account path

  fileUrl = this.sa + '/uploadedfiles/';

  iconUrl = this.sa + '/icons/';

  pwaUrl = 'http://www.xworks.com';

  // fileUrl = this.sa + '/uploadedfiles/';

  loginData = {
    access_token: '',
  };

  currentRole = '';
  messageId = '';
}
